if (!window.getCartQuantityForVariant) {
  window.pdpCartCache = null;

  window.fetchPdpCart = async function() {
    try {
      const cartUrl = (window.routes && window.routes.cart_url) ? window.routes.cart_url : '/cart';
      const res = await fetch(`${cartUrl}.js`);
      if (res.ok) {
        window.pdpCartCache = await res.json();
        return window.pdpCartCache;
      }
    } catch (e) {
      console.error('Error fetching cart:', e);
    }
    return window.pdpCartCache;
  };

  window.getCartQuantityForVariant = function(variantId, cartData) {
    const cart = cartData || window.pdpCartCache;
    if (!cart || !cart.items || !variantId) return 0;
    const targetId = Number(variantId);
    let total = 0;
    for (const item of cart.items) {
      if (Number(item.id) === targetId || Number(item.variant_id) === targetId) {
        total += item.quantity;
      }
    }
    return total;
  };

  window.updatePdpAddToCartButtons = async function(cartData) {
    let cart = cartData;
    if (!cart) {
      cart = await window.fetchPdpCart();
    } else {
      window.pdpCartCache = cart;
    }
    document.querySelectorAll('product-form').forEach((productFormEl) => {
      if (typeof productFormEl.updateButtonState === 'function') {
        productFormEl.updateButtonState(cart);
      }
    });
  };
}

if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        if (!this.form) return;
        if (this.variantIdInput) this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        if (this.submitButton) {
          this.submitButtonText = this.submitButton.querySelector('span');
          if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');
        }

        this.hideErrors = this.dataset.hideErrors === 'true';
        this.isSubmitting = false;

        if (typeof subscribe === 'function') {
          subscribe(PUB_SUB_EVENTS.cartUpdate, (data) => {
            if (data?.cartData?.items) {
              window.pdpCartCache = data.cartData;
            }
            this.updateButtonState(window.pdpCartCache);
          });
          subscribe(PUB_SUB_EVENTS.variantChange, () => {
            this.updateButtonState();
          });
          subscribe(PUB_SUB_EVENTS.optionValueSelectionChange, () => {
            this.updateButtonState();
          });
        }

        window.fetchPdpCart().then((cart) => {
          this.updateButtonState(cart);
        });
      }

      connectedCallback() {
        window.fetchPdpCart().then((cart) => {
          this.updateButtonState(cart);
        });
      }

      updateButtonState(cartData) {
        if (!this.submitButton) return;
        const variantId = this.variantIdInput ? this.variantIdInput.value : null;
        if (!variantId) return;

        const currentText = this.submitButtonText ? this.submitButtonText.textContent.trim() : '';
        const isOutOfStock =
          this.submitButton.dataset.outOfStock === 'true' ||
          this.submitButton.hasAttribute('data-out-of-stock') ||
          currentText === 'Out of Stock' ||
          currentText === 'Sold Out' ||
          currentText === 'Unavailable' ||
          currentText === (window.variantStrings?.soldOut || 'Out of Stock') ||
          currentText === (window.variantStrings?.unavailable || 'Unavailable');

        if (isOutOfStock) {
          this.submitButton.disabled = true;
          this.submitButton.setAttribute('disabled', 'disabled');
          this.submitButton.setAttribute('aria-disabled', 'true');
          this.submitButton.dataset.outOfStock = 'true';
          if (this.submitButtonText) {
            if (currentText !== 'Unavailable' && currentText !== (window.variantStrings?.unavailable || 'Unavailable')) {
              this.submitButtonText.textContent = window.variantStrings?.soldOut || 'Out of Stock';
            }
          }
          return;
        }

        const cartQty = window.getCartQuantityForVariant(variantId, cartData);
        if (cartQty >= 10) {
          this.submitButton.disabled = true;
          this.submitButton.setAttribute('disabled', 'disabled');
          this.submitButton.setAttribute('aria-disabled', 'true');
          if (this.submitButtonText) {
            this.submitButtonText.textContent = 'Added in cart';
          }
        } else {
          this.submitButton.disabled = false;
          this.submitButton.removeAttribute('disabled');
          this.submitButton.removeAttribute('aria-disabled');
          if (this.submitButtonText) {
            this.submitButtonText.textContent = (window.variantStrings && window.variantStrings.addToCart) ? window.variantStrings.addToCart : 'Add To Cart';
          }
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (!this.submitButton) return;
        if (disable) {
          this.submitButton.disabled = true;
          this.submitButton.setAttribute('disabled', 'disabled');
          this.submitButton.setAttribute('aria-disabled', 'true');
          if (text) {
            if (this.submitButtonText) this.submitButtonText.textContent = text;
            if (
              text === (window.variantStrings?.soldOut || 'Out of Stock') ||
              text === (window.variantStrings?.unavailable || 'Unavailable') ||
              text === 'Out of Stock' ||
              text === 'Sold Out' ||
              text === 'Unavailable'
            ) {
              this.submitButton.dataset.outOfStock = 'true';
            }
          } else {
            this.submitButton.dataset.outOfStock = 'true';
          }
        } else {
          this.submitButton.dataset.outOfStock = 'false';
          this.updateButtonState();
        }
      }

      async onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.isSubmitting) return;

        const variantId = this.variantIdInput ? this.variantIdInput.value : null;
        if (!variantId) return;

        if (this.submitButton && (this.submitButton.disabled || this.submitButton.dataset.outOfStock === 'true')) {
          return;
        }

        // Immediately set submitting and show loading spinner UI
        this.isSubmitting = true;
        this.handleErrorMessage();

        if (this.submitButton) {
          this.submitButton.setAttribute('aria-disabled', 'true');
          this.submitButton.disabled = true;
          this.submitButton.classList.add('loading');
        }
        const spinner = this.querySelector('.loading__spinner');
        if (spinner) spinner.classList.remove('hidden');

        const quantityInput = this.form.querySelector('[name="quantity"]');
        const requestedQty = quantityInput ? (parseInt(quantityInput.value, 10) || 1) : 1;

        const config = fetchConfig('json');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        formData.set('quantity', requestedQty.toString());

        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        const linesUpdateDeferred = this.createCartLinesUpdateEvent(variantId, requestedQty);

        try {
          const response = await fetch(`${routes.cart_add_url}`, config).then((res) => res.json());

          if (response.status) {
            publish(PUB_SUB_EVENTS.cartError, {
              source: 'product-form',
              productVariantId: variantId,
              errors: response.errors || response.description,
              message: response.message,
            });
            this.handleErrorMessage(response.description);
            this.dispatchCartErrorEvent(response.description || response.message, 'INVALID');
            linesUpdateDeferred?.reject(new Error(response.description || response.message));

            const soldOutMessage = this.submitButton ? this.submitButton.querySelector('.sold-out-message') : null;
            if (soldOutMessage) {
              this.submitButton.setAttribute('aria-disabled', 'true');
              this.submitButton.disabled = true;
              if (this.submitButtonText) this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
            }
          } else if (!this.cart) {
            this.resolveCartLinesUpdate(linesUpdateDeferred);
            window.location = window.routes.cart_url;
            return;
          } else {
            this.resolveCartLinesUpdate(linesUpdateDeferred);

            if (window.showToast) window.showToast('Item added to cart', 'cart');

            // Render contents and open drawer IMMEDIATELY!
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    CartPerformance.measure("add:paint-updated-sections", () => {
                      this.cart.renderContents(response);
                    });
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              CartPerformance.measure("add:paint-updated-sections", () => {
                this.cart.renderContents(response);
              });
            }

            // Asynchronously update cart cache and publish updates without blocking drawer open
            (async () => {
              try {
                const updatedCart = await window.fetchPdpCart();
                if (window.updateCartCounters) window.updateCartCounters(updatedCart);
                if (!this.error) {
                  publish(PUB_SUB_EVENTS.cartUpdate, {
                    source: 'product-form',
                    productVariantId: variantId,
                    cartData: updatedCart,
                  });
                }
                this.error = false;
                window.updatePdpAddToCartButtons(updatedCart);
              } catch (err) {
                console.error('Background cart update error:', err);
              }
            })();
          }
        } catch (e) {
          console.error(e);
          this.dispatchCartErrorEvent(e.message || 'Network error', 'SERVICE_UNAVAILABLE');
          linesUpdateDeferred?.reject(e);
        } finally {
          this.isSubmitting = false;
          if (this.submitButton) {
            this.submitButton.classList.remove('loading');
          }
          if (spinner) spinner.classList.add('hidden');

          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          CartPerformance.measureFromEvent("add:user-action", evt);
        }
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      createCartLinesUpdateEvent(variantId, quantity) {
        const { CartLinesUpdateEvent } = window.StandardEvents || {};
        if (!CartLinesUpdateEvent) return null;

        const deferred = CartLinesUpdateEvent.createPromise();
        this.dispatchEvent(
          new CartLinesUpdateEvent({
            action: 'add',
            context: 'product',
            lines: [{ merchandiseId: variantId, quantity }],
            promise: deferred.promise,
          })
        );
        return deferred;
      }

      resolveCartLinesUpdate(deferred) {
        if (!deferred) return;
        const { CartLinesUpdateEvent } = window.StandardEvents || {};
        if (!CartLinesUpdateEvent) return;

        const pendingCartDataPromise = typeof CartItems !== 'undefined'
          ? CartItems.fetchCartData()
          : fetch(`${routes.cart_url}.json`).then((response) => response.json());

        pendingCartDataPromise
          .then((cart) => {
            if (!cart?.currency) return deferred.reject(new Error('Missing currency in cart response'));
            deferred.resolve({ cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart) });
          })
          .catch((e) => deferred.reject(e));
      }

      dispatchCartErrorEvent(message, code) {
        const { CartErrorEvent } = window.StandardEvents || {};
        if (!CartErrorEvent) return;
        this.dispatchEvent(new CartErrorEvent({ error: message, code }));
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
